
const parseInvData = data => data?.inventory?.map(({link, vin}) => ({ vdpUrl: link, vin })) || [];

export const getValidatedVins = async(vin, siteId) => {
	const requestObject = {
		widgetName: 'ws-inv-data',
		preferences: {
			'listing.config.id': 'auto-new,auto-used'
		},
		pageAlias: 'INVENTORY_LISTING_DEFAULT_AUTO_ALL',
		locale: 'en_US',
		pageId: 'v9_INVENTORY_SEARCH_RESULTS_AUTO_ALL_V1_1',
		uri: '/all-inventory/index.htm',
		windowId: 'inventory-data-bus1',
		referrer: `https://${siteId}.cms.dealer.com/`,
		host: `${siteId}.cms.dealer.com/`,
		includePricing: 'false',
		inventoryParameters: {
			useWIS: 'true',
			vin
		},
		flags:{
            'vcda-js-environment': 'live',
            'ws-inv-data-fetch-timeout': 5000
        },
		siteId,
		device: 'desktop'
	}

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: '*/*'
        },
        body: JSON.stringify(requestObject)
    };

    const response = await fetch('/api/widget/ws-inv-data/getInventory', options);

    let responseData;

    try {
        responseData = parseInvData(await response.json());
        
    } catch (err) {
        return [];
    }

    return responseData;
}
